module.exports = __webpack_public_path__ + "img/public/SiteIcons/hostStepIcons/description.svg?b91e0097";